import { render, staticRenderFns } from "./YoutubeLoader.vue?vue&type=template&id=52b3bf96&lang=pug"
import script from "./YoutubeLoader.vue?vue&type=script&lang=js"
export * from "./YoutubeLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports